// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p8-1";
export var stateContainer = "_p8-0";